import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiHeart, FiEdit, FiShield, FiUsers, FiArrowRight } = FiIcons;

function PublishingRoadmap() {
  const personas = [
    {
      id: 'christian',
      title: 'Christian',
      subtitle: 'Mindset & Motivation',
      description: 'Ground your writing in gospel truth and calling',
      icon: FiHeart,
      color: 'rose',
      bgColor: 'from-rose-100 to-pink-100',
      textColor: 'text-rose-700',
      borderColor: 'border-rose-200'
    },
    {
      id: 'creator',
      title: 'Creator',
      subtitle: 'Book Planning & Writing',
      description: 'Plan your book and develop your writing practice',
      icon: FiEdit,
      color: 'amber',
      bgColor: 'from-amber-100 to-yellow-100',
      textColor: 'text-amber-700',
      borderColor: 'border-amber-200'
    },
    {
      id: 'caretaker',
      title: 'Caretaker',
      subtitle: 'Publishing Roadmap',
      description: 'Navigate the publishing process with confidence',
      icon: FiShield,
      color: 'emerald',
      bgColor: 'from-emerald-100 to-green-100',
      textColor: 'text-emerald-700',
      borderColor: 'border-emerald-200'
    },
    {
      id: 'connector',
      title: 'Connector',
      subtitle: 'Marketing Mindset & First Steps',
      description: 'Share your work with a heart to serve readers',
      icon: FiUsers,
      color: 'blue',
      bgColor: 'from-blue-100 to-indigo-100',
      textColor: 'text-blue-700',
      borderColor: 'border-blue-200'
    }
  ];

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      {/* Header */}
      <div className="text-center mb-12">
        <h1 className="font-serif text-4xl text-gray-800 mb-4">
          Your Publishing Roadmap
        </h1>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
          Every successful author embodies these four roles. 
          <span className="text-emerald-700 font-medium block mt-2">
            Let's discover where you are and where to focus next.
          </span>
        </p>
      </div>

      {/* Personas Grid */}
      <div className="grid md:grid-cols-2 gap-6 mb-12">
        {personas.map((persona, index) => (
          <Link
            key={persona.id}
            to={`/persona/${persona.id}`}
            className="group block"
          >
            <div className={`bg-gradient-to-br ${persona.bgColor} p-6 rounded-2xl border ${persona.borderColor} hover:shadow-lg transition-all duration-200 transform hover:scale-105 h-full`}>
              <div className="flex items-start space-x-4">
                <div className={`p-3 bg-white rounded-xl shadow-sm group-hover:shadow-md transition-shadow`}>
                  <SafeIcon icon={persona.icon} className={`w-6 h-6 ${persona.textColor}`} />
                </div>
                
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="font-serif text-xl text-gray-800">
                      {index + 1}. {persona.title}
                    </h3>
                    <SafeIcon icon={FiArrowRight} className="w-5 h-5 text-gray-400 group-hover:text-gray-600 transition-colors" />
                  </div>
                  
                  <p className={`font-medium mb-2 ${persona.textColor}`}>
                    {persona.subtitle}
                  </p>
                  
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {persona.description}
                  </p>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>

      {/* Bottom Actions */}
      <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-6 border border-amber-100 text-center">
        <h3 className="font-serif text-xl text-gray-800 mb-3">
          Not sure where to start?
        </h3>
        <p className="text-gray-600 mb-4">
          Take our quick quiz to discover which persona to focus on first.
        </p>
        <Link 
          to="/quiz"
          className="inline-flex items-center space-x-2 bg-amber-600 text-white px-6 py-3 rounded-xl hover:bg-amber-700 transition-colors"
        >
          <span>Take the Quiz</span>
          <SafeIcon icon={FiArrowRight} className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}

export default PublishingRoadmap;